import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";
import PageHeader from "../../Components/PageHeader";
import dc from "../../assets/img/dc.webp";
import dc2 from "../../assets/img/debtnew.jpeg";
import { servicesgetbyslug } from "../../network/Network";
import { baseUrl } from "../../network/ApiUrl";

const Debtcollection = () => {
  const [slug, setSlug] = useState("debt-collection");
  const [service, setService] = useState([]);
  const [heading, setHeading] = useState("");
  const [innerHeading, setinnerHeading] = useState("");
  const [short, setShort] = useState("");
  const [bannerImage, setBannerImage] = useState(null);
  const [newFile, setNewFile] = useState();
  const [fileupload, setFileupload] = useState();
  const [content, setContent] = useState("");
  useEffect(() => {
    let data = {
      slug: `/debt-collection`,
    };
    servicesgetbyslug(data)
      .then((res) => {
        console.log(res, "rrrr");
        setService(res?.data?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [slug]);
  console.log("ser",service)
  return (
    <>
      <Header />
      <PageHeader pagename="Debt Collection" pagelinkname="Services" />

      {/* winning sec starts here */}
      <section className="winning-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="content-wrapper Monetization ">
                {/* <h3>Debt Collection Made Easy with Sherwood</h3> */}
                <h3>{service?.heading}</h3>
                <div className="blue-divider"></div>
                {/* <h5>Debt Collection Made Easy With Sherwood </h5> */}
                {/* <p>
                Debt collection can be a difficult and stressful process. We understand debt collection and are here to help you collect the money you’re owed. Debt collection with Sherwood Partners is the easiest way to get your debts paid. We have a network of experienced debt collection agents throughout the world who are familiar with the process of debt collection.
                </p> */}
                {/* <p> */}
                  {/* Debt collection can be a difficult and stressful process,
                  especially if you're not familiar with the ins and outs of the
                  process. That's where Sherwood Partners comes in. We
                  understand debt collection and we're here to help you get the
                  money you're owed. */}
                  {/* Debt collection can be a difficult and stressful process. That's where Sherwood Partners comes in. We understand debt collection and we're here to help you get the money you're owed.
                </p> */}
                  <p dangerouslySetInnerHTML={{ __html: service?.content }} />
              </div>
            </div>
            <div className="col-lg-6 align-self-center">
              <div className="img-wrapper img-effect">
                <figure>
                  {/* <img src={dc2} className="img-fluid" /> */}
                  <img
                    className="img-fluid"
                    src={baseUrl + service?.bannerImage}
                  />
                </figure>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* winning sec ends here */}

      <Footer />
    </>
  );
};

export default Debtcollection;
